<template>
  <nuxt-img
    :format="imgFormat"
    :densities="imgDensities"
    :sizes="imgSizes"
    :width="imgWidth"
    :height="imgHeight"
    :src="imgSrc"
    :placeholder="tinyPlaceholderSrc"
    :alt="imgAlt"
    :loading="imgLoading"
    @error="handleError" />
</template>

<script setup lang="ts">
import { computed, ref, useImage } from "#imports";

const props = defineProps<{
  imgLoading?: String,
  imgFormat?: String,
  imgDensities?: String,
  imgSizes?: String,
  imgWidth?: String,
  imgHeight?: String,
  imgSrc?: string,
  imgPlaceholder?: String,
  imgAlt?: String,
}>();

const showPlaceholder = ref(false);

const img = useImage();
// Generate a tiny, low-quality 20px version for the placeholder
const tinyPlaceholderSrc = computed<string|null>(() => {
  if (!props.imgSrc) return ''
  return showPlaceholder.value ? (img(props.imgSrc, { width: 20, quality: 20, blur: 5 }) ?? props.imgSrc) : null;
})

function handleError (): void {
  showPlaceholder.value = true;
}
</script>
